import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";

const preloadedState = {
  settings: window.localStorage.getItem("settings") && window.localStorage.getItem("settings") !== undefined && window.localStorage.getItem("settings") !== "undefined" && window.localStorage.getItem("settings") !== "null"
    ? JSON.parse(window.localStorage.getItem("settings"))
    : {},
  user: window.localStorage.getItem("user") && window.localStorage.getItem("user") !== undefined && window.localStorage.getItem("user") !== "undefined" && window.localStorage.getItem("user") !== "null"
    ? JSON.parse(window.localStorage.getItem("user"))
    : {},
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
});

store.subscribe(() => {
  const state = store.getState();

  const stateToPersist = {
    settings: state.settings,
    user: state.user,
  };
  Object.keys(stateToPersist).forEach((key) => {
    localStorage.setItem(key, JSON.stringify(stateToPersist[key]));
  });
});

export default store;
